import { Box, Button, Grid, Typography } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import Page from 'common/shared-ui/src/components/Page';
import ErrorLogo from 'common/shared-ui/src/icons/ErrorLogo';

export const UncaughtError: React.FC = () => {
  const intl = useIntl();

  return (
    <Page
      display='flex'
      alignItems='center'
      justifyContent='center'
      title='Error 404'
      sx={{ height: '100%' }}
    >
      <Grid
        container
        direction='column'
        sx={{
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            marginBottom: '175px',
          }}
        >
          <ErrorLogo />
        </Box>
        <Box
          sx={{
            marginBottom: '26px',
          }}
        >
          <Typography
            variant='h1'
            align='center'
            sx={{
              display: 'inline-flex',
              flexDirection: 'column',
            }}
          >
            {`${intl.formatMessage({ id: 'error' })} `}
            <Box
              component={'span'}
              sx={{
                marginTop: '16px',
                fontWeight: '400',
              }}
            >
              {intl.formatMessage({ id: `error_404` })}
            </Box>
          </Typography>
        </Box>
        <Box
          sx={{
            marginX: 'auto',
          }}
        >
          <Link to='/'>
            <Button disableRipple variant='outlined'>
              <Typography
                variant='h4'
                color='info'
                sx={{
                  fontWeight: 700,
                }}
              >
                {intl.formatMessage({ id: 'back_to_main_page' })}
              </Typography>
            </Button>
          </Link>
        </Box>
      </Grid>
    </Page>
  );
};
